<!-- <div class="d-flex justify-content-between align-items-top flex-wrap gap-2">
    <div class="mx-2">
        <mat-form-field class="w-100">
            <mat-label>Dată</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="dateBorderou" (dateChange)="onDateChange($event)" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="mx-2">
        <button type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
            <i class="fa-solid fa-plus"></i>
            Incarcă
        </button>
        <button type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="print()">
            Print
        </button>
        <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="reset()">
            <i class="fa-solid fa-arrows-rotate"></i>
        </button>
    </div>
</div>
<div *ngIf="current_info" class="m-2 current-info">
    <span>{{ current_info.document_type + '/' + current_info.data}}</span>
    <span> - </span>
    <span class="current-info-link" (click)="downloadBorderouInfo(current_info.id)">{{ current_info.document_file_name
        }}</span>
</div> -->
<div class="table-container">
    <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger">
    </table>
</div>
<div class="section-spinner position-absolute" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>